module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"tuneMic":"Настройте микрофон","micSettingsCheck":"Проверка настройки микрофона перед началом очного собеседования"}}')
  delete Component.options._Ctor
}
